<template>
  <ElDialog
      v-model="isShow"
      :title="isEdit?$t('system.dialog.folder.name'):$t('common.newfolder')"
      :footer="null"
      centered
      :width="520"
      destroyOnClose
      @cancel="close"
      :class="[isHeadLine ? 'headline' : 'noheadline']"
  >
    <div style="display: flex;justify-content: center;align-items: center">
      <span class="title_cdir"
            style="display:inline-block;width: 100px;line-height: 30px;font-size: 13px;font-weight: normal">{{
          $t('common.folder.name')
        }}:</span>
      <el-input
          size="small"
          ref="refInput"
          type="text"
          v-model="fileDirName"
          style="width: 100%;"
          :maxLength="15"
          @keydown.enter.native="createDir"
      />
    </div>
    <template #footer>
      <div class="dialog-footer">
        <ElButton size="small" @click="close">
          {{
            $t("common.cancel")
          }}
        </ElButton>
        <ElButton size="small" type="primary" @click="createDir" :loading="loading">
          {{
            $t("common.confirm")
          }}
        </ElButton>
      </div>
    </template>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, computed, onMounted, nextTick} from 'vue'
import {useStore} from "vuex";
import {addEmailGroupFile, updateEmailGroupFile} from "@/api/sidebar";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const fileDirName = ref("")
const loading = ref(false)
const teamId = computed(() => store.state.email.teamID);
const refInput = ref(null)
const {value, isHeadLine, isEdit, currentItem, isTop, isChangeIsTop} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  isEdit: {type: Boolean, default: false},
  currentItem: {type: Object, default: {}},
  isTop: {type: Number, default: 0},
  isChangeIsTop: {type: Boolean, default: false}
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}

onMounted(() => {
  if (isEdit) {
    fileDirName.value = currentItem.fileName;
  }
  nextTick(() => {
    refInput.value.focus()
  })
})

const isLoading = ref(false)
const createDir = async () => {
  try {
    isLoading.value = true
    const payload = !isEdit ? {
      fileName: fileDirName.value,
      teamId: teamId.value,
      isTop: isTop,
    } : {
      fileName: fileDirName.value,
      id: currentItem?.id,
      isTop: isTop,
    }
    if (isChange.value) {
      delete payload.isTop
    }
    let ApiCheckout = !isEdit ? addEmailGroupFile : updateEmailGroupFile
    let res = await ApiCheckout(payload)
    console.log(res, 'res')
    ElMessage.success(res.message)
    if (!isEdit) {
      fileDirName.value = ""
    }
    isLoading.value = false
    close();
    emit('getList')
  } catch (e) {
    isLoading.value = false
  }
}

const isChange = ref(false)
watch(() => fileDirName.value, (newValue) => {
  isChange.value = true
})
</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

</style>
